export default "__VITE_ASSET__P19dyOBz__"